import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import api from "../api";

// lytepress.com/join/tt/chaguanas — the link on a printed city sheet. It pre-fills the city on the
// shop registration form and remembers which city's link brought them in.
const JoinCity = () => {
  const { countrySlug, citySlug } = useParams();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get(`/cities/${countrySlug}/${citySlug}`)
      .then((r) => {
        localStorage.setItem("lp-join", JSON.stringify({
          key: `${countrySlug}/${citySlug}`, city: r.data.city, country: r.data.country,
        }));
      })
      .catch(() => localStorage.removeItem("lp-join"))
      .finally(() => setReady(true));
  }, [countrySlug, citySlug]);

  if (!ready) return <div className="h-64 rounded-2xl bg-secondary animate-pulse" />;
  return <Navigate to="/register" replace />;
};

export default JoinCity;
